import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { LikeSuccess } from '@app/+product/store/actions/product.action';

/**
 * When a product is added to Like.
 */
const events = getEvents((action: LikeSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productAddToFavorite',
      addToFavoriteType: 'product_page',
      product_brand: action.payload.brand.name,
      product_category: action.payload.category.name,
      product_univers: action.payload.universe.name
    }
  },
  {
    type: 'add_to_Fav',
    container: TagContainer.Media
  }
]);

export default events;
